export default (siteName) => [
    {
        path: 'staff-roles',
        name: 'staff-roles',
        component: () => import('../../components/dashboard/Settings/StaffRoles/index'),
        meta: {
            title: `身份功能設定${siteName}`,
            activeMenu: 'admin',
        },
    },
    {
        path: 'staff-roles/add',
        name: 'staff-roles-add',
        component: () => import('../../components/dashboard/Settings/StaffRoles/edit'),
        meta: {
            title: `身份功能設定${siteName}`,
            activeMenu: 'admin',
        },
    },
    {
        path: 'staff-roles/edit',
        name: 'staff-roles-edit',
        component: () => import('../../components/dashboard/Settings/StaffRoles/edit'),
        meta: {
            title: `身份功能設定${siteName}`,
            activeMenu: 'admin',
        },
    },
];
